<template>

      <div class="rm" :ref="'rm_'+index">
        <div class="rm-form p-30" v-if="selected==index">
          <div v-if="registration_method.registration_method_id==2">
            <div class="row mb-15">
              <input v-model="form.last_name" class="input-text rounded" type="text" placeholder="Last Name" />
            </div>
            <div class="row">
              <input v-model="form.room_number" class="input-text rounded" type="text" placeholder="Room Number" />
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==3">
            <div class="row mb-15 p-rel">
              <input v-model="form.email_address" class="input-text rounded" :class="{ 'warn-input': warn_email }" type="email" placeholder="Email" />
              <transition><p v-if="warn_email" id="warn_email" class="warn">You must provide an email address to continue.</p></transition>
            </div>
            <p class="text-center text-14 mb-0">
              <input type="checkbox" id="news" v-model="form.consent">Yes, I’d like to receive news and special offers from Hotel Zephyr.
            </p>
            <p class="text-center text-14 mb-0 mt-10">
              <span @click="show_notice = !show_notice" class="text-link">Notice at Collection</span>
            </p>
            <div class="notice-at-collection text-left pt-20" v-if="show_notice">
              <p class="text-14 mt-0"><strong>Notice at Collection:</strong> {{ notice_at_collection }}</p>
              <div class="mt-30 text-center"><button class="btn-close" @click="show_notice = false">CLOSE</button></div>
            </div>
          </div>
          
          <div v-if="registration_method.registration_method_id==4" class="row p-rel">
            <input v-model="form.access_code" class="input-text rounded" type="text" placeholder="Access Code" />
          </div>
          <div class="pt-20 mb-15">
            <button @click="emitRegistrationMethodData()" class="btn rounded" type="button">Continue</button>
          </div>
          <p class="text-center text-14 mb-0">By clicking continue you agree to the
            <span @click="selectTermsOfService(index)" class="text-link">Terms and Conditions</span>
          </p>
          <div class="terms-of-service text-left pt-20" v-if="selected_tos==index">
            <div v-html="registration_method.terms_of_service"></div>
            <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
          </div>
        </div>
      </div> <!-- rm -->



</template>
<script>
import Axios from "axios";
export default {
  name: 'registration_method',
  props: ['index','selected','selected_tos','color_background_button','color_text_button','registration_method'],
  data(){
    return{
      // access_code: null,
      // access_code_valid: true,
      // access_code_error_text: 'Required',
      clicked: false,
      show_notice: false,
      warn_email: false,
      form: {
        access_code: '',
        room_number: '',
        first_name: '',
        last_name: '',
        email_address: '',
        consent: false
      },
      revinate: {
        list_token: "3b6a1bba-2713-41dc-b43e-a1333999e2c3",
        url: "https://contact-api.inguest.com/api/add-contacts-to-lists",
      },
      notice_at_collection: `We collect contact information such as your email address when you sign in to our Wi‑Fi. We use this information to provide connectivity, manage your account or access, send service messages, and, where permitted, send marketing communications about hotel offers and events. We may also use this information to comply with legal obligations and protect our systems. We do not sell your information. You may opt out of marketing emails at any time by using the unsubscribe link in each email. For more information on how we use your information and how long it is retained, please visit our Privacy Policy.`,
    }
  },
  watch: {

  },
  mounted(){
  },
  methods: {
    // Send selected Terms of Service back to parent
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },

    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData: async function(){
      // If no access code set, show required text
      if(this.registration_method.type=='accesscode' && !this.form.access_code){
        this.access_code_valid = false;
        return;
      }
      // Email is required for the email registration method. Validate before
      // setting `clicked` so a failed attempt doesn't leave the button dead,
      // and so the guest gets this message instead of an API error.
      if(this.registration_method.registration_method_id=='3' && !this.form.email_address){
        this.warn_email = true;
        return;
      }
      this.warn_email = false;
      if(this.clicked){
        return;
      }
      this.clicked = true;


      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
        email_opt_in: false
      };
      if(this.registration_method.registration_method_id=='1'){
        emitted.rateplan_id = this.registration_method.id;
      } else if(this.registration_method.registration_method_id=='2'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
      } else if(this.registration_method.registration_method_id=='3'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.email_address = this.form.email_address;
        // Skyway also stores the email and the opt-in flag on the registration.
        emitted.email_opt_in = this.form.consent;
      } else if(this.registration_method.registration_method_id=='4'){
        emitted.access_code = this.form.access_code;
      }

      // Add opted-in guests to the Revinate list before continuing
      if(emitted.email_opt_in){
        const revinate_data = {
          tokens: [this.revinate.list_token],
          contacts: [{ email: this.form.email_address }]
        };
        Axios.post(this.revinate.url, revinate_data).then(() => {
          this.$emit('emitRegistrationMethodData', emitted);
        }).catch(() => {
          this.clicked = false;
          this.$emit('error', 'Error registering with email address.');
        });
      } else {
        this.$emit('emitRegistrationMethodData', emitted);
      }
    },
  }
}
</script>
<style scoped>

  .btn {
    background: #ff485c;
    color: #ffffff;
    max-width: 200px;
    padding: 10px;
    border: none;
    transition: background 0.15s ease-in-out;
  }

  /* Explicit hover colour rather than a brightness/opacity filter, which
     previously washed the button out on other properties. */
  .btn:hover,
  .btn:focus {
    background: #e33a4d;
    color: #ffffff;
  }

  .warn-input {
    border: 2px solid #ff485c !important;
  }

  .warn {
    color: #ffffff;
    background: rgba(255, 72, 92, 0.85);
    border-radius: 6px;
    padding: 8px 10px;
    margin: 8px 0 0;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
  }

  .notice-at-collection {
    max-height: 240px;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.45);
    padding: 15px;
    border-radius: 6px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .rm span.text-link {
    color: white;
  }

  .news {
    position: relative;
    top: 2px;
    left: -6px;
  }
</style>
